export const css = {
    root: '_27NxZbSD',
    ' _key': 'afcpe-theme/dojo/variants/default'
};
export default css;
